import * as React from "react";
import {
    PlasmicTransparentDisplay,
    DefaultTransparentDisplayProps
} from "./plasmic/main/PlasmicTransparentDisplay";

export interface TransparentDisplayProps extends DefaultTransparentDisplayProps {
    text: string,
    action: any,
}

function TransparentDisplay({text, action, ...rest}: TransparentDisplayProps) {

    return (<PlasmicTransparentDisplay
        root={{
            onClick: action
        }}
        {...rest} >
        {text}
    </PlasmicTransparentDisplay>);
}

export default TransparentDisplay;
